import React, { useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import useAxios from 'axios-hooks';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';

import { SelectRaw } from '../../../../components';
import BillingForm from './Form';

const Billing = ({ evisit, hasBillingCodeFeature, userId, onBillingCodeChosen }) => {
	const [showForm, setShowForm] = useState(false);
	const [deleting, setDeleting] = useState({});
	const [isChoosingBillingCode, setChoosingBillingCode] = useState(false);

	const [{ data: diagnoses }, getVisitDiagnoses] = useAxios({
		method: 'GET',
		url: `/evisits/${evisit.id}/evisit_diagnosis`,
		params: {
			filter: JSON.stringify({
				include: ['icd_code', 'procedure_code']
			})
		}
	});
	const [{ data, /*loading, error*/ }] = useAxios({
		method: 'GET',
		url: `/providers/${userId}/billing-code-type`
	});

	const handleChoosingBillingCode = (evt) => {
		evt.preventDefault();
		setChoosingBillingCode(true);
	};

	const handleBillingCodeChosen = ({ target }) => {
		onBillingCodeChosen(target.value);
		setChoosingBillingCode(false);
	};

	const handleSaved = () => {
		setShowForm(false);
		// reload diagnoses
		getVisitDiagnoses();
	};

	const handleDeleteDiagnosis = diagnosis => {
		// delete diagnosis and reload diagnoses
		setDeleting(diagnosis);
		axios.delete(`/evisit_diagnoses/${diagnosis.id}`)
			.then(getVisitDiagnoses);
	};

	const { id, end_dttm, patient, billing_code_type_id } = evisit;
	const isOpen = !end_dttm;
	let insurance = {};
	let billingCodes = [];
	let chosenBillingCode = '';

	if (patient && patient.insurances && patient.insurances.length > 0) {
		insurance = patient.insurances[0];
	}
	if (Array.isArray(data)) {
		billingCodes = data.map(({ billing_code_type_id, billing_code_type }) => ({ value: billing_code_type_id, label: billing_code_type }));
		if (!billing_code_type_id) {
			billingCodes.unshift({ value: '', label: 'Choose...' });
		} else {
			const chosenCode = data.find((code) => code.billing_code_type_id == billing_code_type_id);
			if (chosenCode) {
				chosenBillingCode = chosenCode.billing_code_type;
			}
		}
	}

	return (
		<div>
			{showForm && <BillingForm
				onClose={() => setShowForm(false)}
				onSave={handleSaved}
				evisitId={id}
			/>}
			{!showForm &&
				<React.Fragment>
					{isOpen && hasBillingCodeFeature && (
						<div className="mb-lg pb-lg" style={{ borderBottom: '1px dashed #ddd' }}>
							<h4>Billing Code</h4>
								<div className="row">
									<div className="col-md-6 col-md-offset-3">
										{isChoosingBillingCode ? (
											<SelectRaw
												selectedValue={billing_code_type_id}
												onChange={handleBillingCodeChosen}
												options={billingCodes}
											/>
										) : (
											<a
												href="#"
												className={cn('editable', 'editable-click', { 'editable-empty': !billing_code_type_id })}
												onClick={handleChoosingBillingCode}
											>{billing_code_type_id && !isEmpty(chosenBillingCode) ? chosenBillingCode : 'Choose billing code'}</a>
										)}
									</div>
								</div>
						</div>
					)}
					<div className="diagnoses">
						{insurance && insurance.id && (
							<div className="mb-lg pb-lg" style={{ borderBottom: '1px dashed #ddd' }}>
								<h4>Insurance Information</h4>
								<div className="row">
									<div className="col-sm-3 text-right"><strong>Payer</strong></div>
									<div className="col-sm-3">{insurance.payer_name}</div>
									<div className="col-sm-3 text-right"><strong>Member ID</strong></div>
									<div className="col-sm-3">{insurance.member_id}</div>
								</div>
							</div>
						)}
						{isOpen && <div className="pull-right">
							<button
								type="button"
								className="btn btn-labeled btn-info"
								onClick={() => setShowForm(true)}
							>
								<span className="btn-label"><i className="fa fa-plus"></i></span>Add Diagnosis
							</button>
						</div>}
						<h4>Diagnoses</h4>
						<table className="table table-striped">
							<thead>
								<tr>
									<th>Diagnosis - ICD10</th>
									<th>Procedure</th>
								</tr>
							</thead>
							<tbody>
								{(!diagnoses || diagnoses.length === 0) ? (
									<tr>
										<td colSpan={2}>No diagnoses found</td>
									</tr>
								) : (
									diagnoses.map(diagnosis => (
										<tr key={diagnosis.id}>
											<td>
												{diagnosis.icd_code ? (
													<span>{diagnosis.icd_code.icd_code} - {diagnosis.icd_code.icd_code_description}</span>
												) : (
													<span>No ICD code found</span>
												)}
											</td>
											<td>
												{diagnosis.procedure_code ? (
													<span>{diagnosis.procedure_code.procedure_code} - {diagnosis.procedure_code.procedure_code_description}</span>
												) : (
													<span>No procedure code found</span>
												)}
											</td>
											{isOpen && (
												(deleting && deleting.id === diagnosis.id) ? (
													<td className="text-right">
														<span className="fa fa-spin fa-spinner" />
													</td>
												) : (
													<td className="text-right">
														<button
															className="btn btn-danger delete invisible"
															onClick={() => handleDeleteDiagnosis(diagnosis)}
														><em className="fa fa-remove"></em></button>
													</td>
												)
											)}
										</tr>
									))
								)}
							</tbody>
						</table>
					</div>
				</React.Fragment>
			}
		</div>
	);
};

Billing.propTypes = {
	evisit: PropTypes.object.isRequired,
	hasBillingCodeFeature: PropTypes.bool,
	userId: PropTypes.number,
	onBillingCodeChosen: PropTypes.func.isRequired,
};

export default Billing;
